export const opacity = {
  disabled: 0.5
} as const;

export type Opacity = typeof opacity;
